import { buildMetaArgs } from 'ra-data-hasura'

const customBuildMetaArgs = (query, variables, aorFetchType) => {
  const resourceName = query.name
  const fetchType = aorFetchType

  if (process.env.REACT_APP_CUSTOM_QUERIES) {
    console.log(`customBuildMetaArgs resource ${resourceName}`)
    console.log(`customBuildMetaArgs fetchType ${fetchType}`)
    console.log(`customBuildMetaArgs query ${JSON.stringify(query)}`)
    console.log(`customBuildMetaArgs variables ${JSON.stringify(variables)}`)
  }

  const result = buildMetaArgs(query, variables, aorFetchType)

  if (process.env.REACT_APP_CUSTOM_QUERIES) {
    console.log(`customBuildFields result ${JSON.stringify(result)}`)
  }

  return result
}

export default customBuildMetaArgs
